import React, { useState, useEffect } from "react";

function FAQHeader() {

    const [menuOpen, setMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [scrolled, setScrolled] = useState(false);

    // Disable background scroll
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [menuOpen]);

    // Header Scroll
    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);

    // Close full menu
    const handleCloseMenu = () => {
        setMenuOpen(false);
        setActiveDropdown(null);
    };

    const handleDropdownToggle = (dropdown) => {
        if (window.innerWidth <= 990) {
            setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
        }
    };

    return (
        <header className={scrolled ? "header-scrolled" : ""}>

            <div className="Header">

                {/* Logo */}
                <div className="logo">
                    <a href="/">

                        {/* Logo Change */}
                        <img
                            src="/logo-remove.png"
                            alt="logo"
                        />

                    </a>
                </div>

                {/* Mobile Menu Button */}
                <div
                    className={`menu-toggle ${menuOpen ? "active" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    id="menu-toggle"
                >
                    <span className="icon">
                        {menuOpen ? "✕" : "☰"}
                    </span>
                </div>

                {/* Overlay */}
                {menuOpen && (
                    <div
                        className="overlay"
                        onClick={handleCloseMenu}
                    ></div>
                )}

                {/* Right Side */}
                <div className={`header-right ${menuOpen ? "show" : ""}`}>

                    <nav>
                        <ul className="nav-links" id="nav-link">

                            {/* Dropdown */}
                            <li className="dropdown padding">

                                <div className="dropdown-title" id="dropdown" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDropdownToggle("about");
                                }}>

                                    {/* About Link */}
                                    <p id="about">Home</p>

                                    {/* Arrow Click */}
                                    <span
                                        className={`arrow ${activeDropdown === "about" ? "rotate" : ""}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleDropdownToggle("about");
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height={18} width={18}><path d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z" /></svg>
                                    </span>

                                </div>

                                {/* Dropdown Menu */}
                                <ul className={`dropdown-menu ${activeDropdown === "about" ? "show-dropdown" : ""}`}>
                                    <li><a href="/" onClick={handleCloseMenu}>Overview</a></li>
                                    <li><a href="/#home-box4" onClick={handleCloseMenu}>Why customers love Loyalific</a></li>
                                    <li><a href="/#tools-section" onClick={handleCloseMenu}>How Loyalific works</a></li>
                                    <li><a href="/#home-box7" onClick={handleCloseMenu}>Tools & workflows</a></li>
                                    <li><a href="/Reviews-section" onClick={handleCloseMenu}>Customer reviews & references</a></li>
                                    <li><a href="/#home-box12" onClick={handleCloseMenu}>Who Loyalific is for</a></li>
                                </ul>

                            </li>

                            {/* <li className="dropdown padding">

                                <div className="dropdown-title" id="dropdown" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDropdownToggle("feature");
                                }}>

                                    <p id="feature">Feature</p>

                                    <span
                                        className={`arrow ${activeDropdown === "feature" ? "rotate" : ""}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleDropdownToggle("feature");
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height={18} width={18}><path d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z" /></svg>

                                    </span>

                                </div>

                                <ul className={`dropdown-menu ${activeDropdown === "feature" ? "show-dropdown" : ""}`}>
                                    <li><a href="/card-design-feature" onClick={handleCloseMenu}>Card Designer</a></li>
                                    <li><a href="/web-stamper-feature" onClick={handleCloseMenu}>Web Stamper</a></li>
                                    <li><a href="/customersharing-feature-box1" onClick={handleCloseMenu}>Customer Sharing & Enrollment</a></li>
                                    <li><a href="/customermanagement-feature-box1" onClick={handleCloseMenu}>Customer Management</a></li>
                                    <li><a href="/" onClick={handleCloseMenu}>Push Notifications</a></li>
                                    <li><a href="/staffmanagement-feature-box1" onClick={handleCloseMenu}>Staff Management</a></li>
                                    <li><a href="/Reviewfeature" onClick={handleCloseMenu}>Customer reviews & references</a></li>
                                </ul>

                            </li> */}

                            <li className="padding">
                                <a href="/pricing" onClick={handleCloseMenu}>
                                    Pricing
                                </a>
                            </li>

                            <li className="padding">
                                <a href="/faq" onClick={handleCloseMenu}>
                                    FAQs
                                </a>
                            </li>

                        </ul>
                    </nav>

                    {/* Buttons */}
                    <div className="header-btns">

                        <a
                            href="https://merchant.loyalific.com/login"
                            className="login-btn" id="login-btn"
                            onClick={handleCloseMenu}
                        >
                            Sign Up
                        </a>

                        <a
                            href="https://merchant.loyalific.com/login"
                            className="signup-btn"
                            onClick={handleCloseMenu}
                        >
                            Get Started
                        </a>

                    </div>

                </div>
            </div>
        </header>
    );
}

export default FAQHeader;